module.exports = __webpack_public_path__ + "img/id-2017.1c57c1c0.png";